import ReadyToBecomeAstronautSection from './ready-to-become-astronaut-section';

export default ReadyToBecomeAstronautSection;
